import BreadcrumbsBar from './BreadcrumbsBar';

export default BreadcrumbsBar;
